import React from 'react'
import { isRTL } from 'utils/utils'
import styled from 'styled-components'
import Divider from '@material-ui/core/Divider'
import TypographyPro from '../../themes/TypographyPro'
import type { TypographyVariants } from 'utils/theme/GlobalStyle'

const StyledTitleContainer = styled.div`
	display: flex;
	flex-direction: column;
	//@media (max-width: 576px) {
	//	hr {
	//		display: none;
	//	}
	//}
`

// Our own styled material ui typography title that has our required styling
const StyledTitle = styled(TypographyPro)<{ $isRTL: boolean }>`
	text-align: ${({ $isRTL }) => ($isRTL ? 'right' : 'left')};
	right: ${({ $isRTL }) => ($isRTL ? '44px' : 0)};
	left: ${({ $isRTL }) => (!$isRTL ? '44px' : 0)};
	display: flex;
	color: var(--footerAndDarkBackgrounds);

	@media (max-width: 576px) {
		right: ${({ $isRTL }) => ($isRTL ? '23px' : 0)};
		left: ${({ $isRTL }) => (!$isRTL ? '23px' : 0)};
	}
`

const StyledDivider = styled(Divider)<{ $dividerWidth: string }>`
	width: ${({ $dividerWidth }) => $dividerWidth || '100%'};
	margin: auto;
	@media (max-width: 576px) {
		width: ${({ $dividerWidth }) => $dividerWidth || '90%'};
		align-self: center;
	}
`

interface Props {
	style?: React.CSSProperties
	className?: string
	locale?: string
	showUpperDivider?: boolean
	showLowerDivider?: boolean
	children?: React.ReactNode
	dividerWidth?: string
	ignoreRTL?: boolean
	variant?: TypographyVariants
	testId: string
}

const Title: React.FC<Props> = ({
	style,
	className = '',
	locale = 'en_US',
	showUpperDivider = false,
	showLowerDivider = false,
	children = null,
	dividerWidth = '100%',
	ignoreRTL = false,
	variant = 'h1',
	testId,
}) => (
	<StyledTitleContainer style={style} className="app-title">
		{showUpperDivider && <StyledDivider $dividerWidth={dividerWidth} />}
		<StyledTitle
			variant={variant}
			$isRTL={ignoreRTL ? false : isRTL(locale)}
			// $showLowerDivider={showLowerDivider}
			className={className}
			data-testid={testId}
		>
			{children}
		</StyledTitle>
		{showLowerDivider && <StyledDivider $dividerWidth={dividerWidth} />}
	</StyledTitleContainer>
)

export default React.memo(Title)
